export enum HttpMethods {
   GET = "GET",
   POST = "POST",
   PUT = "PUT",
   DELETE = "DELETE",
   PATCH = "PATCH",
}
export enum HttpCodes {
   OK = 200,
   CREATED = 201,
   NO_CONTENT = 204,
   BAD_REQUEST = 400,
   UNAUTHORIZED = 401,
   FORBIDDEN = 403,
   NOT_FOUND = 404,
   INTERNAL_SERVER_ERROR = 500,
   SERVICE_UNAVAILABLE = 503,
}

export const INVALID_WEARABLE_VITAL_READING_CODE = 255

export const UNASSIGNED_WEARABLE = "Unassigned"

export const MAIN_SUPPORT_EMAIL = "support@rs.care"

export const MAIN_SUPPORT_PHONE = "844-373-2778"

export const AUTO_REFRESH_INTERVAL_MS = 4 * 60 * 60 * 1000 //4 hours

export enum TestId {
   CUSTOMER_FACILITIES_TABLE_TEXT_FIELD = "customer-facilities-table-text-field",
   LOGIN_EMAIL_INPUT = "login-email-input",
   LOGIN_PASSWORD_INPUT = "login-password-input",
   LOGIN_LOGIN_BUTTON = "login-login-button",
   LOGIN_ERROR_MESSAGE = "login-error-message",
   AUDIO_PLAYER_AUDIO = "audio-player-audio",
   AUDIO_PLAYER_AUDIO_SOURCE = "audio-player-audio-source",
   AUDIO_PLAYER_PLAY_BUTTON = "audio-player-play-button",
   AUDIO_PLAYER_STOP_BUTTON = "audio-player-stop-button",
   CELL_ALERT_CARD = "cell-alert-card",
   NUMBER_BADGE = "number-badge",
   CELL_CARD = "cell-card",
   CELL_CARD_VITALS = "cell-card-vitals",
   CELL_CARD_ID = "cell-card-id",
   CELL_ICON = "cell-icon",
   DISABLED_ALARM_ICON = "disabled-alarm-icon",
   LOG_CARD_ICON = "log-card-icon",
   CELL_CUSTOM_ICON = "cell-custom-icon",
   CELL_WITH_DOOR_SENSOR_ICON = "cell-with-door-sensor-icon",
   BATTERY_EMPTY_ICON = "battery-empty-icon",
   MAINTENANCE_ICON = "maintenance-icon",
   DISCONNECTED_ICON = "disconnected-icon",
   HUMAN_PRESENCE_ICON = "human-presence-icon",
   MOVEMENT_ICON = "movement-icon",
   CELL_CARD_TITLE = "cell-card-title",
   CLEAR_ALERT_MODAL_FORM_SENT_TEXT = "clear-alert-modal-form-sent-text",
   ALERT_MODAL_MANAGE_BUTTON = "alert-modal-manage-button",
   ALERT_MODAL_SWAP_BUTTON = "alert-modal-swap-button",
   ALERT_MODAL_VIEW_BUTTON = "alert-modal-view-button",
   CLEAR_ALERT_MODAL_NAME_INPUT = "clear-alert-modal-name-input",
   CLEAR_ALERT_MODAL_REPORT_NOTE_INPUT = "clear-alert-modal-report-note-input",
   CLEAR_ALERT_MODAL_CLEAR_BUTTON = "clear-alert-modal-clear-button",
   FLOOR_OVERVIEW_SETTINGS_BUTTON = "floor-overview-settings-button",
   FLOOR_OVERVIEW_UNASSIGNED_WEARABLES_BUTTON = "floor-overview-unassigned-wearables-button",
   WEARABLE_CARD_UNASSIGNED_ICON = "wearable-card-unassigned-icon",
   FLOOR_OVERVIEW_CHARGING_WEARABLES_BUTTON = "floor-overview-charging-wearables-button",
   ALERT_CARD_HEART_RATE_ICON = "cell-alert-card-heart-rate-icon",
   FLOOR_OVERVIEW_OCCUPIED_CELLS_TEXT = "floor-overview-occupied-cells-text",
   FLOOR_OVERVIEW_LAST_READ_TEXT = "floor-overview-last-read-text",
   FLOOR_OVERVIEW_LOCATION_GROUP_LABEL = "floor-overview-location-group-label",
   FLOOR_OVERVIEW_LOCATION_TOTAL_COUNT = "floor-overview-location-total-count",
   FLOOR_OVERVIEW_UNKNOWN_LOCATION_LABEL = "floor-overview-unknown-location-label",
   FLOOR_OVERVIEW_UNKNOWN_LOCATION_TOTAL_COUNT = "floor-overview-unknown-location-total-count",
   ALERT_CARD_UPPER_THRESHOLD_ICON = "cell-alert-card-upper-threshold-icon",
   USERS_INVITE_USER_BUTTON = "users-invite-user-button",
   USERS_RESEND_INVITE_BUTTON = "users-resend-invite-button",
   USERS_TAB = "users-tab",
   USER_FORM_EMAIL_INPUT = "user-form-email-input",
   USER_FORM_NAME_INPUT = "user-form-name-input",
   USER_FORM_LAST_NAME_INPUT = "user-form-last-name-input",
   USER_FORM_PHONE_NUMBER_INPUT = "user-form-phone-number-input",
   USER_FORM_ROLES_DROPDOWN = "user-form-roles-dropdown",
   USER_FORM_ROLES_DROPDOWN_OPTION = "user-form-roles-dropdown-option",
   USER_FORM_SAVE_BUTTON = "user-form-save-button",
   USER_FORM_SUCCESS_HEADER = "user-form-success-header",
   USER_FORM_SUCCESS_NAME_TEXT = "user-form-success-name",
   USER_FORM_SUCCESS_LAST_NAME_TEXT = "user-form-success-last-name",
   USER_FORM_SUCCESS_EMAIL_TEXT = "user-form-success-email",
   USER_FORM_SUCCESS_PHONE_NUMBER_TEXT = "user-form-success-phone-number",
   USER_FORM_SUCCESS_ROLE_TEXT = "user-form-success-role",
   USER_FORM_SUCCESS_BUTTON = "user-form-success-button",
   USERS_TABLE_EMAIL_CELL_TEXT = "users-table-email-cell-text",
   USER_FORM_ERROR_MESSAGE = "user-form-error-message",
   USER_FORM_EMAIL_HELPER_TEXT = "user-form-email-helper-text",
   WEARABLE_ALERT_CARD = "wearable-alert-card",
   ALERT_SETTING_EDIT_ICON = "alert-setting-edit-icon",
   ALERT_SETTING_SAVE_ICON = "alert-setting-save-icon",
   ALERT_SETTING_CANCEL_ICON = "alert-setting-cancel-icon",
   ALERT_SETTING_DELETE_ICON = "alert-setting-delete-icon",
   DIALOG_TITLE = "dialog-title",
   DELETE_ALARM_DIALOG_TITLE = "delete-alarm-dialog-title",
   MUTE_ALARM_DIALOG_TITLE = "mute-alarm-dialog-title",
   DYNAMIC_THRESHOLD_DIALOG_TITLE = "dynamic-threshold-dialog-title",
   TEST_ALARM_DIALOG_TITLE = "test-alarm-dialog-title",
   TIMEZONE_REQUIRED_DIALOG_TITLE = "timezone-required-dialog-title",
   DIALOG_BUTTON = "dialog-button",
   DIALOG_CLOSE = "dialog-close",
   TEST_ALARM_DIALOG_BUTTON = "test-alarm-dialog-button",
   TEST_ALARM_BUTTON = "test-alarm-button",
   DISABLE_ALARM_BUTTON = "disable-alarm-button",
   ENABLE_ALARM_BUTTON = "enable-alarm-button",
   DELETE_ALARM_BUTTON = "delete-alarm-button",
   AUTO_OCCUPANCY_TOGGLE = "auto-occupancy-toggle",
   FAST_ALARM_CLEARANCE_TOGGLE = "fast-alarm-clearance-toggle",
   OPEN_CELL_SCHEDULING_TOGGLE = "open-cell-scheduling-toggle",
   TEST_ALARM_TRIGGER_TOGGLE = "test-alarm-trigger-toggle",
   MEASUREMENT_SYSTEM_SETTING = "measurement-system-setting",
   MEASUREMENT_SYSTEM_METRIC_RADIO = "measurement-system-metric-radio",
   MEASUREMENT_SYSTEM_IMPERIAL_RADIO = "measurement-system-imperial-radio",
   MEASUREMENT_SYSTEM_SPINNER = "measurement-system-spinner",
   DISPLAY_LOCATION_TOGGLE = "display-location-toggle",
   CELL_CARD_SIZE_SMALL_RADIO = "cell-card-size-small-radio",
   CELL_CARD_SIZE_MEDIUM_RADIO = "cell-card-size-medium-radio",
   CELL_CARD_SIZE_LARGE_RADIO = "cell-card-size-large-radio",
   INMATE_CARD_SIZE_SMALL_RADIO = "inmate-card-size-small-radio",
   INMATE_CARD_SIZE_MEDIUM_RADIO = "inmate-card-size-medium-radio",
   INMATE_CARD_SIZE_LARGE_RADIO = "inmate-card-size-large-radio",
}
